import AssignedCard from "./AssignedCard";
export default AssignedCard;
